<template>
    <div class="vtext">
        会员信息列表
    </div>
    <div class="viplist">
        <Noshu :disabled="loading" :lengths="infolists.length"></Noshu>

        <div class="pagechoose">

            显示结果：

            <div class="pagees">

                <input v-model="pageSize" type="number" min="1" max="99" @keyup.enter="pageSizechange">

            </div>

        </div>
        <div class="vipt">
            <div class="screen">
                <el-cascader v-model="value" :options="options" placeholder="类型筛选:" @change="handleChange" />
            </div>
            <div class="search">
                <div style="width: 24px;height: 24px;text-align: center;">
                    <img style="width: 100%;height: 100%;" src="../../assets/secree.png" alt="">
                </div>
                <div>
                    <input type="text" placeholder="关键词搜索" v-model="keyseach" @keyup.enter="wordkey">
                </div>
            </div>
            <div class="calendar">
                <el-date-picker class="choosedatas" v-model="choosedata" type="daterange" range-separator="-"
                    start-placeholder="" end-placeholder=" " @change="changedata" format="MM.DD" />
            </div>
            <div class="exdown" @click="openDialog">
                <img src="../../assets/goodlist/xdown.png" alt="">&nbsp; 下载
            </div>
        </div>
        <div class="vipporpe" v-loading="loading">
            <table>
                <thead>
                    <tr>
                        <th style="width: 40px;">
                            <div style="width: 100%;height: 46px;display: flex;align-items: center;">
                                <!-- <el-checkbox /> -->
                            </div>
                        </th>
                        <th style="width: 70px;">编号</th>
                        <th style="width: 173px;">名称</th>
                        <th style="width: 183px;">真实姓名</th>
                        <th style="width: 160px;">手机号</th>

                        <th style="width: 160px;">注册时间</th>
                        <th style="width: 130px;">身份状态</th>
                        <th class="states" style="cursor: pointer;width: 130px;"
                            :style="{ 'color': sortFiled == 1 && sort == true ? '#1787FF' : '#4D585F' }"
                            @click="state(1)">


                            <div style="display: flex;align-items: center;justify-content: center;">


                                状态
                                <SvgIcon v-if="sortFiled == 1 && sort == true" class="svg-icon" iconClass="paixu2">
                                </SvgIcon>

                                <SvgIcon v-else class="svg-icon" iconClass="paixu"></SvgIcon>

                            </div>
                        </th>
                        <th class="states" style="cursor: pointer;width: 130px;"
                            :style="{ 'color': sortFiled == 2 && sort == true ? '#1787FF' : '#4D585F' }"
                            @click="state(2)">


                            <div style="display: flex;align-items: center;justify-content: center;">


                                实名认证
                                <SvgIcon v-if="sortFiled == 2 && sort == true" class="svg-icon" iconClass="paixu2">
                                </SvgIcon>

                                <SvgIcon v-else class="svg-icon" iconClass="paixu"></SvgIcon>

                            </div>
                        </th>
                        <th class="states" style="cursor: pointer;width: 130px;"
                            :style="{ 'color': sortFiled == 3 && sort == true ? '#1787FF' : '#4D585F' }"
                            @click="state(3)">
                            <div style="display: flex;align-items: center;justify-content: center;">


                                封禁状态
                                <SvgIcon v-if="sortFiled == 3 && sort == true" class="svg-icon" iconClass="paixu2">
                                </SvgIcon>

                                <SvgIcon v-else class="svg-icon" iconClass="paixu"></SvgIcon>

                            </div>

                        </th>
                        <!-- <th class="states" style="width: 80px;">操作</th> -->
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(item, index) in infolists" :key="index" @click="gomessage(item.uid, item.isVip)"
                        style="cursor: pointer;">
                        <td @click.stop> <el-checkbox v-model="item.chooses"
                                @change="choosexid(item.uid, item.chooses)" />
                        </td>
                        <td>
                            {{ item.uid }}
                        </td>
                        <td>
                            {{ item.uusername }}
                        </td>
                        <td>
                            {{ item.urealname || '暂无' }}
                        </td>
                        <td>
                            {{ item.utel || '暂无' }}
                        </td>

                        <td>
                            {{ datahuan(item.uregdate) }}
                        </td>
                        <td>
                            {{ item.isVip == 1 ? '普通会员' : '助花会员' }} <br>
                            {{ tiquan(item.isPartner) }}
                        </td>
                        <td>
                            <div class="statea">
                                <div :class="item.umark == 1 ? 'state' : 'state2'">
                                    {{ item.umark == 1 ? '已审核' : '未审核' }}
                                </div>
                            </div>
                        </td>
                        <td>
                            <div class="statea">
                                <div :class="item.uauthrealname == 3 ? 'state' : 'state2'">
                                    {{ item.uauthrealname == 3 ? '已实名' : '未实名' }}
                                </div>
                            </div>
                        </td>
                        <td>
                            <div class="statea">
                                <div :class="item.closeStatus == 0 ? 'state2' : 'state'">
                                    {{ item.closeStatus == 0 ? '已封禁' : '未封禁' }}
                                </div>
                            </div>
                        </td>


                    </tr>
                </tbody>
            </table>

            <div style=" height: 70px;"></div>

        </div>
        <div class="example-pagination-block" :style="{ 'display': wordKey.length >= 1 ? 'none' : '' }">
            <el-pagination background v-model:current-page="pageCount" layout="prev, pager, next" :pager-count="5"
                :page-count="total" :disabled="loading" />
        </div>
        <div class="example-pagination-iskey" :style="{ 'display': wordKey.length >= 1 ? '' : 'none' }">
            <el-pagination background v-model:current-page="pageCount" layout="prev, pager, next" :pager-count="5"
                :page-count="9999999" :disabled="loading" />
        </div>
    </div>
    
    <yc-mask ref="maskRef" :close-on-click-modal="false">
        <div class="dialog">
            <div class="dialogt">
                <div>
                    导出属性
                </div>
                <div @click="closeDialog">
                    <el-icon>
                        <Close />
                    </el-icon>
                </div>
            </div>
            <div class="exchooses">
                <div class="exchoosee" v-for="(item, index) in exports" :key="index">
                    <div>{{ item.name }}</div>
                    <div>
                        <el-switch v-model="item.chooses" @change="changeex(item.experts, item.chooses)" />
                    </div>
                </div>

            </div>
            <div class="downex">
                <div class="dowm" @click="productExport">
                    下载excel
                </div>
            </div>
        </div>
    </yc-mask>
</template>

<script setup>
import { onMounted, ref, reactive, watch, nextTick } from 'vue';
import { useRouter } from 'vue-router';
// import Pagintion from '@/components/Pagination.vue'
import api from '@/api/api'
import Noshu from '@/components/Noshu.vue'

import { ElMessage, ElMessageBox } from 'element-plus'
let loading = ref(false)


let wordKey = ref('')
let keyseach = ref('')
let pageCount = ref(1)
const router = useRouter()
const infolists = ref([])
let startTime = ref('')
let endTime = ref('')
let nowdata = new Date()
let mextdata = new Date()
let total = ref(1)
let screenType = ref('0')
const value = ref([])
let sort = ref(false)
let sortFiled = ref('0')
const options = reactive([
    {
        value: '0',
        label: '全部',
    },
    {
        value: '1',
        label: '用户ID（门铃号）',
    },
    {
        value: '2',
        label: '手机号',
    },
    {
        value: '3',
        label: '用户名',
    }
])
let listinfo = ref(0)


watch(pageCount, (newValue, oldValue) => {
    console.log('watch 已触发', newValue, oldValue)
    if (newValue < oldValue) {
        nextPage.value = 2
    } else {

        nextPage.value = 1
    }
    nextTick(() => {
        infoList();
    });
})
let nextPage = ref(0)
let pageSize = ref(7)

const pageSizechange = () => {
    if (pageSize.value <= 1) {
        pageSize.value = 1
    }
    if (pageSize.value >= 99) {
        pageSize.value = 99
    }
    console.log('pageSize', pageSize.value)
    infoList()
}
const infoList = async () => {
    console.log('nextPage', nextPage)
    loading.value = true

    try {
        let data
        if (wordKey.value.length > 1) {
            data = {
                screenType: screenType.value,
                endTime: endTime.value,
                pageCount: pageCount.value,
                pageSize: pageSize.value,
                startTime: startTime.value,
                wordKey: wordKey.value,
                sortFiled: sortFiled.value,
                sort: sort.value,
                nextPage: nextPage.value,
                maxId: listinfo.value
            }
        } else {
            data = {
                screenType: screenType.value,
                endTime: endTime.value,
                pageCount: pageCount.value,
                pageSize: pageSize.value,
                startTime: startTime.value,
                // wordKey: wordKey.value,
                sortFiled: sortFiled.value,
                sort: sort.value,
                nextPage: nextPage.value,
                maxId: listinfo.value
            }
        }
        console.log('data', data)
        const res = await api.infoList(data)
        console.log(res)
        if (res.code == 401) {
            ElMessageBox.alert('登录已过期请重新登入！', '', {

                confirmButtonText: 'OK',
                callback: (action) => {
                    router.push({
                        path: '/login'
                    })
                },
            })
            // router.push('login')
        }
        if (res.success) {
            loading.value = false

            if (res.data) {
                for (let index = 0; index < res.data.members.length; index++) {
                    res.data.members[index].chooses = false
                }
                infolists.value = res.data.members.slice(0, pageSize.value)
                total.value = (Math.ceil(res.data.total / pageSize.value))
                console.log(res.data.members)
                console.log(res.data.total)
                listinfo.value = infolists.value[infolists.value.length - 1].uid
            } else {
                infolists.value = []
            }
        }


    } catch (error) {
        console.log(error)
    }
}


onMounted(() => {
    pageCount.value = 1
    infoList()
})
const wordkey = () => {
    wordKey.value = keyseach.value
    pageCount.value = 1
    sortFiled.value = 0

    infoList()
}
const tiquan = (isPartner) => {
    if (isPartner == 200) {
        return '村店合伙人'
    } else if (isPartner == 150) {
        return '镇配合伙人'
    } else if (isPartner == 100) {
        return '区县合伙人'
    } else {
        return ''
    }
}
const state = (states) => {
    pageCount.value = 1
    infolists.value = []
    if (sortFiled.value != states) {
        sortFiled.value = states
        sort.value = true
    } else {
        sortFiled.value = states
        sort.value = !sort.value
    }
    // sortFiled.value = states
    // sort.value = !sort.value
    nextPage.value = 0
    infoList()
    //    console.log(states)
}



//导出
import ycMask from '@/components/mask/mask.vue'
//相关变量
let exports = ref([])
let chooseex = ref([])
let pids = ref([])
//关闭弹窗
let closeDialog = () => {
    maskRef.value.closeMask();
};
//获取遮罩的实例
let maskRef = ref(null);
//导出的遮罩层
let openDialog = async () => {
    const res = await api.exportFieldScreen(5)
    console.log(res)
    let values = Object.values(res.data);
    for (let a = 0; a < values.length; a++) {
        let parts = values[a].split("_");
        let data = {
            chooses: false,
            name: parts[0],
            experts: parts[1]
        }
        exports._rawValue.push(data)
    }
    console.log(exports)
    maskRef.value.showMask();
};
//筛选表头
const changeex = (experts, chooses) => {
    console.log(experts, chooses)
    if (chooses) {
        chooseex._rawValue.push(experts)
    } else {
        let index = chooseex._rawValue.indexOf(experts);
        chooseex._rawValue.splice(index, 1)
    }
    console.log(chooseex._rawValue)
}
//筛选条数
const choosexid = (pid, choose) => {
    console.log(pid, choose)
    if (choose) {
        pids._rawValue.push(pid)
    } else {
        let index = pids._rawValue.indexOf(pid);
        pids._rawValue.splice(index, 1)
    }
    console.log(pids._rawValue)
}
//下载
const productExport = async () => {
    let a = pids._rawValue.join(",");
    let b = chooseex._rawValue.join(",");

    let data = {
        productType: 5,
        // endTime: endTime.value, 
        userListId: a,
        screenListFiled: b,
        // startTime: startTime.value,
        // wordKey: choosekey.value
    }

    // let data = {
    //     productType: 1,
    //     // endTime: endTime.value, 
    //     productListId: pids._rawValue,
    //     screenListFiled: chooseex._rawValue,
    //     // startTime: startTime.value,
    //     // wordKey: choosekey.value
    // }
    console.log(a, b)

    console.log(data)

    let res = await api.memberExport(data)
    console.log(res)
    // window.URL.createObjectURL(res)
    let blob = new Blob([res], { type: "application/vnd.ms-excel" });
    let url = window.URL.createObjectURL(blob);
    let link = document.createElement('a');
    link.download = "product.xls";
    link.href = url;
    link.click();

}



const choosedata = ref([nowdata, mextdata])
const changedata = (e) => {
    console.log('时间改变', e)
    if (e == null) {
        e = ['', '']
    }
    startTime.value = datahuan(e[0])
    endTime.value = datahuan(e[1])
    console.log(startTime.value)
    console.log(endTime.value)
    sortFiled.value = 0
    infoList()
}




const datahuan = (days) => {
    if (days) {
        const date = new Date(days)
        const year = date.getFullYear()
        const month = date.getMonth() + 1
        const day = date.getDate()
        return `${year}-${month}-${day}`
    } else {
        return '暂无数据'
    }

}
const handleChange = (value) => {
    console.log(value)
    screenType.value = value[0]
}
const gomessage = (userId, identity) => {
    router.push({
        path: '/home/viplist/vipmeessage',
        query: {
            userId: userId,
            identity: identity
        }
    })

}


//跳转页面
const changepige = (val) => {


    pageCount.value = val

    infoList()


}

</script>

<style lang="scss" scoped>
::v-deep .el-checkbox {


    .el-checkbox__input {
        height: 20px;

        .el-checkbox__inner {
            width: 20px;
            height: 20px;
            border-radius: 10px;
        }

        .el-checkbox__inner {
            &::after {
                top: 4px;
                left: 8px;
            }

        }
    }
}

::v-deep .choosedatas {
    width: 100%;
    height: 100%;
    background-color: #FAFAFA;
    --el-input-border-color: transparent;
    cursor: pointer;

    input {
        font-size: 16px;
        color: #718096;
        cursor: pointer;
    }

}

::v-deep .el-input {
    width: 168px;
    height: 48px;
    font-size: 16px;
    --el-input-text-color: #718096;
    --el-input-border-color: transparent;

    .el-input__wrapper {
        background: #FAFAFA !important;

        .el-icon {
            width: 26px;
            height: 26px;

            svg {
                width: 26px;
                height: 26px;
            }
        }
    }

    ::placeholder {
        font-weight: 400;
        font-size: 14px;
        color: #718096;
    }

}

::v-deep .example-pagination-block {
    position: absolute;
    bottom: 15px;
    right: 34px;

    .number,
    .btn-quicknext,
    .is-last,
    .is-first {
        background-color: transparent !important;
    }

    // .el-pager{
    //     display: none;
    // }

    .is-active {
        background-color: #FAFAFA !important;
        color: #1787FF !important;
        border-radius: 8px;
    }

}

::v-deep .example-pagination-iskey {
    position: absolute;
    bottom: 15px;
    right: 34px;

    .number,
    .btn-quicknext,
    .is-last,
    .is-first {
        background-color: transparent !important;
    }

    .el-pager {
        display: none;
    }

    .is-active {
        background-color: #EBF3FF !important;
        color: #1787FF !important;
        border-radius: 8px;
    }
}


.vtext {
    height: 50px;
    font-size: 32px;
    font-weight: 400;
    color: #0A1629;
    line-height: 50px;
}

.viplist {
    position: relative;
    margin-top: 25px;
    height: calc(100% - 85px);
    min-width: 1166px;
    // min-height: 662px;
    background: #FFFFFF;
    border-radius: 8px;
    box-sizing: border-box;

    .pagechoose {
        position: absolute;
        bottom: 0px;
        left: 0px;
        width: 100%;
        height: 70px;
        padding-left: 20px;
        box-sizing: border-box;
        display: flex;
        align-items: center;

        .pagees {
            width: 71px;
            height: 40px;
            border: 1px solid #EEEFF2;
            border-radius: 8px;
            padding: 8px 0 0 0px;
            box-sizing: border-box;

            input {
                width: 80%;


            }
        }
    }

    .vipporpe {
        width: 100%;
        // padding-left: 15px;
        box-sizing: border-box;



        table {
            width: 100%;
            border-collapse: collapse;
            border-spacing: 0;
            padding: 0;
            margin: 0;

            thead {
                width: 100%;
                height: 46px;
                text-align: left;
                display: table-header-group;
                font-size: 14px;
                font-weight: 400;
                color: #4D585F;
                border-bottom: 1px solid #EEEFF2;

                th {
                    vertical-align: middle;
                }

                th:first-child {
                    padding-left: 15px;

                }

                .states {
                    text-align: center;

                    .svg-icon {
                        margin: 5px 0 0 3px;
                        width: 16px;
                        height: 16px;


                    }
                }
            }

            tbody {
                tr {

                    height: 71px;
                    font-size: 14px;
                    font-weight: 400;
                    color: #000000;
                    border-bottom: 1px solid #EEEFF2;


                    td:first-child {
                        padding-left: 15px;

                    }

                    td:last-child {
                        width: 66px;
                        padding-right: 9px;

                        .operate {
                            width: 70px;

                            color: #1787FF;
                            font-weight: 400;
                            font-size: 12px;
                            margin: 0 auto;
                            padding: 3px;
                            cursor: pointer;
                            text-align: center;

                            div {

                                height: 15px;
                                line-height: 15px;
                                margin-bottom: 6px;
                            }

                            .operates {
                                display: flex;
                                justify-content: space-between;

                            }

                        }
                    }

                    td {

                        vertical-align: middle;

                        .statea {
                            width: 100%;
                            height: 100%;
                            display: flex;
                            align-items: center;
                            justify-content: center;

                            .state {
                                width: 66px;
                                height: 36px;
                                background: #EBF3FF;
                                border-radius: 4px;
                                text-align: center;
                                line-height: 36px;
                                font-size: 14px;
                                font-weight: 400;
                                color: #1787FF;
                            }

                            .state2 {
                                width: 66px;
                                height: 36px;
                                background: rgb(252, 241, 231);
                                border-radius: 4px;
                                text-align: center;
                                line-height: 36px;
                                font-size: 14px;
                                font-weight: 400;
                                color: rgb(243, 182, 133);
                            }
                        }


                    }


                }

                tr:hover {
                    background-color: #f3f3f3;
                }
            }

        }
    }

    .vipt {
        padding-top: 17px;
        margin-left: 15px;
        display: flex;

        .screen {
            width: 168px;
            height: 48px;
            background: #FAFAFA;
            border-radius: 8px;
            margin-right: 24px;
        }

        .search {
            width: 412px;
            height: 48px;
            margin-right: 14px;
            background: #FAFAFA;
            // box-shadow: 0px 6px 58px 0px rgba(196, 203, 214, 0.1);
            border-radius: 8px;
            display: flex;
            align-items: center;
            padding-left: 20px;
            box-sizing: border-box;

            input {
                width: 300px;
                border: none;
                outline: none;
                font-size: 16px;
                background: #FAFAFA;

            }

            ::placeholder {
                font-weight: 400;
                font-size: 14px;
                color: #7D8592;
            }

        }

        .calendar {
            width: 168px;
            height: 48px;
            background: #FAFAFA;
            border-radius: 8px;



        }

        .exdown {
            width: 101px;
            height: 48px;
            background: #FAFAFA;
            border-radius: 8px;
            margin-left: 31px;
            display: flex;
            align-items: center;
            justify-content: center;
            font-weight: 400;
            font-size: 14px;
            color: #718096;
            cursor: pointer;


            img {
                width: 17px;
                height: 21px;
            }
        }

    }
}

.dialog {
    position: relative;
    width: 500px;
    height: 608px;
    background: #FFFFFF;
    border-radius: 8px;
    overflow: hidden;

    .dialogt {
        display: flex;
        justify-content: space-between;
        align-items: center;
        font-size: 18px;
        font-weight: 600;
        color: rgba(0, 0, 0, 0.88);
        margin-bottom: 20px;
        padding: 23px 36px 0 35px;
    }

    .exchooses {
        padding: 23px 36px 0 35px;
        height: 400px;
        overflow: auto;

        .exchoosee {
            display: flex;
            height: 38px;
            justify-content: space-between;
            font-size: 14px;
            font-weight: 400;
            color: #111827;
            align-items: center;
            margin-top: 13px;
        }
    }

    .downex {
        .dowm {
            width: 121px;
            height: 51px;
            background: #3686FF;
            border-radius: 8px;
            text-align: center;
            line-height: 51px;
            font-size: 17px;
            font-family: PingFangSC, PingFang SC;
            font-weight: 400;
            color: #FFFFFF;
        }

        display: flex;
        align-items: center;
        justify-content: center;
        width: 500px;
        height: 120px;
        background: #F2F8FC;

    }

}
</style>